// Surfaces on the verdict view when the user's jurisdiction is SCOTLAND.
// Explains why there's no £4.99 paid CTA: per-property Scottish council tax
// data (peer bands, comparable sales) isn't openly published in the same
// way as HM Land Registry PPD and PropertyData cover for England + Wales.
// We can still show area-level evidence (statistics.gov.scot Data Zone
// sales), but it isn't enough on its own to build a property-specific
// appeal pack — so we surface the read and point users at the free
// Scottish Assessor route.
import { Linking, Pressable, StyleSheet, Text, View } from 'react-native'
import { colors, fontFamily, radius, space } from '../tokens'

export const ScotlandViewOnlyBanner = () => (
  <View style={styles.outer}>
    <Text style={styles.eyebrow}>Scotland coverage — view-only</Text>
    <Text style={styles.body}>
      Scotland's per-property council tax data isn't openly published, so we can't yet build the
      full evidence pack we offer for England and Wales properties. The area-level sales evidence
      above (from the Scottish Government's published Data Zone aggregates) is the most we can
      responsibly show without per-property comparables.
    </Text>
    <Text style={styles.body}>
      If the area-level signal supports an appeal, you can challenge your band directly with your
      local Scottish Assessor — it's free.
    </Text>
    <Pressable
      accessibilityRole="link"
      onPress={() => Linking.openURL('https://www.saa.gov.uk/')}
      style={styles.linkButton}
    >
      <Text style={styles.linkText}>Find your local Assessor at saa.gov.uk →</Text>
    </Pressable>
  </View>
)

const styles = StyleSheet.create({
  outer: {
    backgroundColor: colors.surface,
    borderRadius: radius.lg,
    borderWidth: 1,
    borderColor: colors.border,
    padding: 20,
    gap: space[8],
  },
  eyebrow: {
    fontFamily: fontFamily.body,
    fontSize: 12,
    fontWeight: '700',
    color: colors.muted,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  body: {
    fontFamily: fontFamily.body,
    fontSize: 14,
    lineHeight: 21,
    color: colors.ink,
  },
  linkButton: {
    alignSelf: 'flex-start',
    paddingVertical: space[4],
  },
  linkText: {
    fontFamily: fontFamily.body,
    fontSize: 14,
    fontWeight: '600',
    color: colors.accent2,
  },
})
